import React from 'react';
import './LiquidBackground.css';

const LiquidBackground = () => {
  return (
    <div className="liquid-background">
      <div className="liquid-blob liquid-blob-1"></div>
      <div className="liquid-blob liquid-blob-2"></div>
      <div className="liquid-blob liquid-blob-3"></div>
    </div>
  );
};

export default LiquidBackground;